import Guiding from './guidingPrinciples';

export default Guiding;
